import React from 'react';
import Headline from 'headline';
import categories from 'data/categories.json';
import ScratchedLink from 'shared/scratched-nav-item';
import s from './aside-cats.module.scss';

export default function AsideCategories(props) {
  const omit = ['Uncategorized', 'brands', 'component', 'featured'];
  const parsedCategories = Object.values(categories).filter(
    ({ name, parent }) => parent === 0 && !omit.includes(name)
  );
  const latestFirst = [
    parsedCategories.filter(({ name }) => (name === 'latest'))[0],
   ...parsedCategories.filter(({ name }) => (name !== 'latest'))
  ];
  return (
    <ul className={s.root}>
      <Headline h2 className={s.title}>
        Categories
        <span className={s.line} />
      </Headline>
      <div className={s.categoriesWrapper}>
        {latestFirst.map(({ name, slug }) => {
          return (
            <li key={`cats-${name}`} className={s.navigation}>
              <ScratchedLink dark {...{ category: name, href: `/${slug}` }} />
            </li>
          );
        })}
      </div>
    </ul>
  );
}
